var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#F9F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 42.6665C38.6667 40.4574 35.6819 38.6665 32 38.6665C28.3181 38.6665 25.3333 40.4574 25.3333 42.6665M44 38.667C44 37.0267 42.3545 35.6171 40 34.9998M20 38.667C20 37.0267 21.6455 35.6171 24 34.9998M40 29.648C40.8183 28.9156 41.3333 27.8512 41.3333 26.6665C41.3333 24.4574 39.5425 22.6665 37.3333 22.6665C36.3089 22.6665 35.3743 23.0516 34.6667 23.685M24 29.648C23.1817 28.9156 22.6667 27.8512 22.6667 26.6665C22.6667 24.4574 24.4575 22.6665 26.6667 22.6665C27.6911 22.6665 28.6257 23.0516 29.3333 23.685M32 34.6665C29.7909 34.6665 28 32.8756 28 30.6665C28 28.4574 29.7909 26.6665 32 26.6665C34.2091 26.6665 36 28.4574 36 30.6665C36 32.8756 34.2091 34.6665 32 34.6665Z",
    stroke: "#6941C6",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEmployees);
export default __webpack_public_path__ + "static/media/Total Employees.88918ea60d5606e4f78feb617e44767a.svg";
export { ForwardRef as ReactComponent };